<template>
  <div id="Photo-wrap">
    <div class="header">车家</div>
    <div class="container">
      <div class="photo_part">
        <div class="corner_icon"><img src="../assets/image/Photo/chejia_corner_icon.png"/></div>
        <div class="caption">本人身份证</div>
        <div class="idCard_part">
          <div class="idCard_front_show">
            <div>
              <img :src="idCardFrontBase64"/>
              <input type="file" accept="image/*" id="idCardFront" class="photo" data-code="1" @change="inputPhoto"/>
            </div>
            <div>
              <p>上传身份证正本</p>
              <img src="../assets/image/Photo/chejia_2.png"/>
            </div>
          </div>
          <div class="idCard_reverse_show">
            <div>
              <img :src="idCardReverseBase64"/>
              <input type="file" accept="image/*" id="idCardReverse" class="photo" data-code="2" @change="inputPhoto"/>
            </div>
            <div>
              <p>上传身份证副本</p>
              <img src="../assets/image/Photo/chejia_2.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="photo_part">
        <div class="corner_icon"><img src="../assets/image/Photo/chejia_corner_icon.png"/></div>
        <div class="caption">本人驾驶证</div>
        <div class="driving_license_part">
          <div class="driving_license_front_show">
            <div>
              <img :src="drivingLicenseFrontBase64"/>
              <input type="file" accept="image/*" id="drivingLicenseFront" class="photo" data-code="3" @change="inputPhoto"/>
            </div>
            <div>
              <p>上传驾驶证正本</p>
              <img src="../assets/image/Photo/chejia_2.png"/>
            </div>
          </div>
          <div class="driving_license_reverse_show">
            <div>
              <img :src="drivingLicenseReverseBase64"/>
              <input type="file" accept="image/*" id="drivingLicenseReverse" class="photo" data-code="4" @change="inputPhoto"/>
            </div>
            <div>
              <p>上传驾驶证副本</p>
              <img src="../assets/image/Photo/chejia_2.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="photo_part">
        <div class="corner_icon"><img src="../assets/image/Photo/chejia_corner_icon.png"/></div>
        <div class="caption">本人银行卡</div>
        <div class="driving_license_part">
          <div class="driving_license_front_show">
            <div>
              <img :src="bankCardFrontBase64"/>
              <input type="file" accept="image/*" id="bankCardFront" class="photo" data-code="7" @change="inputPhoto"/>
            </div>
            <div style="position: relative">
              <p>上传银行卡正面</p>
              <img src="../assets/image/Photo/chejia_2.png"/>
              <div class="question_mark" ref="question"><img src="../assets/image/Photo/icon_question_mark.jpg"></div>
              <div class="question_mark_tip" v-if="isQuestionMarkPartShowFlag">
                <p>请上传与本人手机号码相关联的银行卡</p>
              </div>
            </div>
          </div>
          <div class="driving_license_reverse_show"></div>
        </div>
      </div>
      <div class="marital_status_part">
        <div class="marital_status_show">
          <div><p>婚姻</p></div>
          <input @click="showMaritalStatusOption" type="text" v-model="currentMaritalStatusName" readonly="readonly"/>
          <div>
            <img src="../assets/image/Homepage/chejia_5.png"/>
          </div>
        </div>
      </div>
      <div class="photo_part" v-show="matePartShowFlag">
        <div class="corner_icon"><img src="../assets/image/Photo/chejia_corner_icon.png"/></div>
        <div class="caption">配偶身份证</div>
        <div class="mate_idCard_part">
          <div class="mate_idCard_front_show">
            <div>
              <img :src="mateIdCardFrontBase64"/>
              <input type="file" accept="image/*" id="mateIdCardFront" class="photo" data-code="5" @change="inputPhoto"/>
            </div>
            <div>
              <p>上传身份证正本</p>
              <img src="../assets/image/Photo/chejia_2.png"/>
            </div>
          </div>
          <div class="mate_idCard_reverse_show">
            <div>
              <img :src="mateIdCardReverseBase64"/>
              <input type="file" accept="image/*" id="mateIdCardReverse" class="photo" data-code="6" @change="inputPhoto"/>
            </div>
            <div>
              <p>上传身份证副本</p>
              <img src="../assets/image/Photo/chejia_2.png"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" :class="{boxShowStatu_footer: matePartShowFlag}">
      <button @click="subPhotoData">下一步</button>
    </div>
    <!-- 婚姻状态模态选项窗口 -->
    <!-- 遮罩层 -->
    <div class="mask_layer" v-show="maskLayerShowFlag" @click="showMaritalStatusOption"></div>
    <div class="event_box" v-show="eventBoxShowFlag" @click="showMaritalStatusOption">
      <div v-for="item in eventDataList" @click="selectedOption(item.statusCode)"><p>{{item.statusName}}</p></div>
    </div>
  </div>
</template>

<script>

  import bankCardFrontUrl from '../assets/image/Photo/bank_card.jpg'
  import idCardFrontUrl from '../assets/image/Photo/chejia_1.png'
  import idCardReverseUrl from '../assets/image/Photo/chejia_1_1.png'
  import drivingLicenseFrontUrl from '../assets/image/Photo/chejia_3.png'
  import drivingLicenseReverseUrl from '../assets/image/Photo/chejia_3_1.png'
  import { Toast } from 'mint-ui'
  import { Indicator } from 'mint-ui'
  import common from '../utils/common'
  // import Exif from 'exif-js'

  export default {
    name: "Phone",
    data(){
      return {
        // op: null,
        idc: null,
        mobile: null,
        matePartShowFlag: false, // 配偶照片上传部分显示判断flag
        maskLayerShowFlag: false, // 遮罩层显示判断flag
        eventBoxShowFlag: false, // 婚姻状态模态弹窗显示判断flag
        isQuestionMarkPartShowFlag: false, // 银行卡提示显示判断flag
        currentMaritalStatusName: '未婚', // 当前婚姻状态名称 默认‘未婚’
        currentMaritalStatusCode: 0, // 当前婚姻状态code值 默认‘未婚’code
        idCardFrontBase64: idCardFrontUrl,
        idCardReverseBase64: idCardReverseUrl,
        drivingLicenseFrontBase64: drivingLicenseFrontUrl,
        drivingLicenseReverseBase64: drivingLicenseReverseUrl,
        mateIdCardFrontBase64: idCardFrontUrl,
        mateIdCardReverseBase64: idCardReverseUrl,
        bankCardFrontBase64: bankCardFrontUrl,
        eventDataList: [ // 婚姻状态
          {
            statusName: '未婚',  // 婚姻状态名称
            statusCode: 1 // 婚姻状态code
          },
          {
            statusName: '已婚',
            statusCode: 2
          },
          {
            statusName: '丧偶',
            statusCode: 3
          },
          {
            statusName: '离婚',
            statusCode: 4
          }
        ]
      }
    },
    computed: {
      mobilePhone(){
        return sessionStorage.getItem("mobilePhone")
      },
      userId(){
        return sessionStorage.getItem("userId")
      }
    },
    mounted(){
      const that = this
      window.scrollTo(0, 0)
      sessionStorage.setItem("backFlag", 'true')
      document.addEventListener('click', function(e) {
        if(!that.$refs.question.contains(e.target)) {
          that.isQuestionMarkPartShowFlag = false
        }else{
          that.isQuestionMarkPartShowFlag = true
        }
      })
      that.$nextTick(function () {
        that.idc = that.userId
        that.mobile = that.mobilePhone;
        if(common.trimAll(that.mobile) == null){
          that.$router.push({
            path: '/',
            name: "Homepage",
            params: ''
          })
        }
      })
    },
    methods: {
      // 婚姻状态弹窗显示、消失事件
      showMaritalStatusOption(){
        if(this.eventBoxShowFlag){
          this.maskLayerShowFlag = false,
          this.eventBoxShowFlag = false
        }else{
          this.maskLayerShowFlag = true,
            this.eventBoxShowFlag = true
        }
      },
      // 婚姻状态选中事件，‘已婚’、或 非‘已婚’状态页面显示不同
      selectedOption(code){
        if(code == 2){
          this.matePartShowFlag = true
          this.currentMaritalStatusName = '已婚'
          this.currentMaritalStatusCode = 2
        }else if (code == 1){
          this.matePartShowFlag = false
          this.currentMaritalStatusName = '未婚'
          this.currentMaritalStatusCode = 1
        }else if(code == 3) {
          this.matePartShowFlag = false
          this.currentMaritalStatusName = '丧偶'
          this.currentMaritalStatusCode = 3
        }else{
          this.matePartShowFlag = false
          this.currentMaritalStatusName = '离婚'
          this.currentMaritalStatusCode = 4
        }
      },

      // 上传或拍摄照片
      inputPhoto: function (e) {
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        });
        let files = e.target.files || e.dataTransfer.files;;
        if (!files.length) {
          Indicator.close();
          return
        }else{
          let picValue = files[0];
          this.imgPreview(e.target.dataset.code,picValue);
        }
      },
      imgPreview: function (code,file) {
        let self = this;
        let Orientation;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function(){
          Orientation = Exif.getTag(this, 'Orientation');
        });
        // self.op = Orientation +'/-----'
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;

        if (/^image/.test(file.type)) {
          // 创建一个reader
          let reader = new FileReader();
          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function (data) {
            let result = data.srcElement.result;
            let img = new Image();
            img.src = result;
            img.onload = function () {
              let expectWidth = this.naturalWidth;
              let expectHeight = this.naturalHeight;
              if (this.naturalWidth > this.naturalHeight) {
                expectWidth = 640;
                expectHeight = expectWidth * this.naturalHeight / this.naturalWidth;
              } else if (this.naturalHeight > this.naturalWidth) {
                expectHeight = 640;
                expectWidth = expectHeight * this.naturalWidth / this.naturalHeight;
              }
              let canvas = document.createElement("canvas");
              let ctx = canvas.getContext("2d");
              canvas.width = expectWidth;
              canvas.height = expectHeight;
              ctx.drawImage(this, 0, 0, expectWidth, expectHeight);
              let compressImg = canvas.toDataURL("image/jpeg", 1);
              let fileSize = compressImg.length-(compressImg.length/8)*2;
              // Toast({
              //   message: fileSize/1024,
              //   className: 'longMsgStyle'
              // })
              console.log(fileSize/1024)
              switch(code)
              {
                case '1':
                  self.idCardFrontBase64 = compressImg
                  break;
                case '2':
                  self.idCardReverseBase64 = compressImg
                  break;
                case '3':
                  self.drivingLicenseFrontBase64 = compressImg
                  break;
                case '4':
                  self.drivingLicenseReverseBase64 = compressImg
                  break;
                case '5':
                  self.mateIdCardFrontBase64 = compressImg
                break;
                case '6':
                  self.mateIdCardReverseBase64 = compressImg
                  break;
                case '7':
                  self.bankCardFrontBase64 = compressImg
                  break;
                default:
                  return;
              }
              Indicator.close();
            }
          }
        }
      },
      subPhotoData(){
        const that = this
        const router = that.$router
        if(that.idCardFrontBase64 == idCardFrontUrl){
          Toast({
            message: '请上传本人身份证正本',
            className: 'longMsgStyle'
          })
          return
        }
        if(that.idCardReverseBase64 == idCardReverseUrl){
          Toast({
            message: '请上传本人身份证副本',
            className: 'longMsgStyle'
          })
          return
        }
        if(that.drivingLicenseFrontBase64 == drivingLicenseFrontUrl){
          Toast({
            message: '请上传本人驾驶证正本',
            className: 'longMsgStyle'
          })
          return
        }
        if(that.drivingLicenseReverseBase64 == drivingLicenseReverseUrl){
          Toast({
            message: '请上传本人驾驶证副本',
            className: 'longMsgStyle'
          })
          return
        }
        if(that.bankCardFrontBase64 == bankCardFrontUrl){
          Toast({
            message: '请上传本人银行卡正本',
            className: 'longMsgStyle'
          })
          return
        }
        if(that.currentMaritalStatusCode == 2){
          if(that.mateIdCardFrontBase64 == idCardFrontUrl){
            Toast({
              message: '请上传配偶身份证正本',
              className: 'longMsgStyle'
            })
            return
          }
          if(that.mateIdCardReverseBase64 == idCardReverseUrl){
            Toast({
              message: '请上传配偶身份证副本',
              className: 'longMsgStyle'
            })
            return
          }
        }else{
          that.mateIdCardFrontBase64 = null
          that.mateIdCardReverseBase64 = null
        }
        const obj = {}
        obj.idcardTop = that.idCardFrontBase64,
        obj.idcardBottom = that.idCardReverseBase64,
        obj.driveTop = that.drivingLicenseFrontBase64,
        obj.driveBottom = that.drivingLicenseReverseBase64,
        obj.mateTop = that.mateIdCardFrontBase64,
        obj.mateBottom = that.mateIdCardReverseBase64
        obj.bankCard = that.bankCardFrontBase64
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        });
        let objAll = {}
        objAll.img = obj
        objAll.idC= that.idc
        objAll.marryStatus = that.currentMaritalStatusCode
        objAll.mobile = that.mobile
        this.$axios({
            method: 'post',
            url: '/marketing/upload',
            data:  objAll,
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function (res) {
          Indicator.close();
          router.push({
            path: '/userInfoCommit_HomeAndWork',
            name: "UserInfoCommit_HomeAndWork",
            params: {}
          })
        }).catch(function (error) {
          Indicator.close();
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          })
          return
        })

      }
    },

  }

</script>

<style>

  .longMsgStyle{
    margin: 0 auto;
    width: 60%;
    left: 0!important;
    right: 0!important;
    transform: translate(-0%, -50%)!important;
  }
  html{
    background-color: #fff;
  }
  #Photo-wrap{
    width: 100vw;
  }

  #Photo-wrap > .header{
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background-color: #fff;
    color: #222;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    text-align: center;
    z-index: 8;
  }

  #Photo-wrap > .container {
    width: 100%;
  }
  #Photo-wrap > .container > .photo_part {
    position: relative;
    margin: 0 auto;
    width: 6.69rem;
    height: 3.58rem;
    background-color: #ffffff;
    box-shadow: 1.3px 8.9px 34.8px 14.2px
  rgba(71, 69, 250, 0.04);
    border-radius: 0.2rem;
  }
  #Photo-wrap > .container > .photo_part:nth-child(2){
    margin-top: 0.32rem;
  }

  #Photo-wrap > .container > .photo_part:nth-child(3){
    margin-top: 0.32rem;
  }
  #Photo-wrap > .container > .photo_part:last-child{
    margin-top: 0.6rem;
  }
  #Photo-wrap > .container > .photo_part > .caption{
    padding-top: 0.28rem;
    width: 100%;
    font-size: 0.30rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.30rem;
    letter-spacing: -0.3px;
    color: #222222;
    text-align: center;
  }
  #Photo-wrap > .container > .photo_part > .corner_icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.58rem;
    font-size: 0;
    border-top-left-radius: 0.2rem;
    overflow: hidden;
  }
  #Photo-wrap > .container > .photo_part > .corner_icon > img {
    width: 100%;
  }
  .idCard_part,.driving_license_part,.mate_idCard_part{
    margin-top: 0.74rem;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }
  .idCard_front_show,
  .mate_idCard_front_show,
  .driving_license_front_show,
  .idCard_reverse_show,
  .mate_idCard_reverse_show,
  .driving_license_reverse_show {
    width: 2.30rem;
    height: 1.78rem;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }
  .idCard_reverse_show,
  .driving_license_reverse_show,
  .mate_idCard_reverse_show {
  margin-left: 1.05rem;
  }
  .idCard_front_show > div:first-child,
  .idCard_reverse_show > div:first-child,
  .mate_idCard_front_show > div:first-child,
  .mate_idCard_reverse_show > div:first-child,
  .driving_license_front_show > div:first-child,
  .driving_license_reverse_show > div:first-child  {
    position: relative;
    width: 2.30rem;
    max-height: 1.70rem;
    font-size: 0;
  }
  .idCard_front_show > div:last-child,
  .idCard_reverse_show > div:last-child,
  .mate_idCard_front_show > div:last-child,
  .mate_idCard_reverse_show > div:last-child,
  .driving_license_front_show> div:last-child,
  .driving_license_reverse_show> div:last-child {
    width: 100%;
    height: 0.24rem;
    font-size: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
  }
  .idCard_front_show > div:first-child > img,
  .idCard_reverse_show > div:first-child > img,
  .mate_idCard_front_show > div:first-child > img,
  .mate_idCard_reverse_show > div:first-child > img,
  .driving_license_front_show > div:first-child > img,
  .driving_license_reverse_show > div:first-child > img  {
    /*display: none;*/
    width: 100%;
    max-height: 1.4rem;
  }
  .idCard_front_show > div:first-child > input,
  .idCard_reverse_show > div:first-child > input,
  .mate_idCard_front_show > div:first-child > input,
  .mate_idCard_reverse_show > div:first-child > input,
  .driving_license_front_show > div:first-child > input,
  .driving_license_reverse_show > div:first-child > input  {
    position: absolute;
    top: 0;
    display:block;
    height:100% ;
    width: 100%;
    z-index: 2;
    opacity: 0;
  }
  .idCard_front_show > div:last-child > p,
  .idCard_reverse_show > div:last-child > p,
  .mate_idCard_front_show > div:last-child > p,
  .mate_idCard_reverse_show > div:last-child > p,
  .driving_license_front_show> div:last-child > p,
  .driving_license_reverse_show> div:last-child > p {
    font-size: 0.24rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.24rem;
    letter-spacing: -0.2px;
    color: #222222;
  }
  .idCard_front_show > div:last-child > img,
  .idCard_reverse_show > div:last-child > img,
  .mate_idCard_front_show > div:last-child > img,
  .mate_idCard_reverse_show > div:last-child > img,
  .driving_license_front_show> div:last-child > img,
  .driving_license_reverse_show> div:last-child > img {
    margin-left: 0.12rem;
    width: 0.25rem;
    height: 0.18rem;
  }
  .marital_status_part{
    /*border: 1px solid green;*/
    margin-top: 0.8rem;
    width: 100%;
  }
  .marital_status_part > .marital_status_show{
    position: relative;
    border-bottom: solid 0.04rem #000000;
    margin: 0 auto;
    width: 4.5rem;
    height: 0.84rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }
  .marital_status_show > div:first-child{
    position: absolute;
    left: 0.27rem;
    top: 0;
    width: 1.125rem;
    height: 0.8rem;
    display: flex;
    align-items: center;
    font-size: 0.28rem;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 0.03rem;
    color: #222222;
    z-index: 2;
  }
  .marital_status_show > input{
    margin: 0;
    padding: 0;
    width: 4.75rem;
    height: 0.8rem;
    font-size: 0.32rem;
    line-height: 0.8rem;
    display: block;
    border-width: 0;
    outline: 0;
    text-align: center;
  }
  .marital_status_show > div{
    position: absolute;
    top:40%;
    right: 0.34rem;
    width: 0.19rem;
    height: 0.11rem;
    font-size: 0;
  }
  .marital_status_show > div > img{
    width: 100%;
    pointer-events: none;
  }
  #Photo-wrap > .footer{
    margin-top: 2.88rem;
    padding-bottom: 1.76rem;
    width: 100%;
    height: 1rem;
  }
  #Photo-wrap > .footer > button{
    padding: 0;
    margin: 0;
    display: block;
    margin: 0 auto;
    width: 5.83rem;
    height: 1rem;
    font-size: 0.28rem;
    font-weight: normal;
    font-stretch: normal;
    color: #fff;
    border-width: 0;
    outline: none;
    background-image: linear-gradient(-90deg,
    #2694ff 0%,
    #42da94 100%),
  linear-gradient(
    #4080ee,
    #4080ee);
    background-blend-mode: normal,
    normal;
    border-radius: 0.12rem;
  }
  #Photo-wrap > .boxShowStatu_footer{
    margin-top: 1.1rem;
    padding-bottom: 2.06rem;
  }
  /* 婚姻状态窗口样式 */
  .mask_layer{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #222!important;
    opacity: .3;
    z-index: 9;
  }
  .event_box{
    padding-top: .5rem;
    padding-bottom: .6rem;
    position: fixed;
    bottom: 0;
    left: 0;;
    right: 0;
    width: 100%;
    z-index: 10;
    background-color: #fff;
  }
  .event_box > div{
    border-bottom: 0.02rem solid #f4f4f4;
    margin:  0 auto;
    width: 86.4%;
    height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .event_box > div > p {
    width: 100%;
    font-size: 0.28rem;
  }


  .question_mark {
    position: absolute;
    left: -0.27rem;
    width: 0.27rem;
    height: 0.27rem;
    font-size: 0;
  }

  .question_mark > img {
    width: 100%;
  }

  .question_mark_tip {
    margin: 0;
    padding: 0.1rem 0.24rem;
    position: absolute;
    top: 200%;
    left: -0.1rem;
    border-radius: 0.15rem;
    background-color: rgba(0,0,0,0.8);
    z-index: 10;
  }

  .question_mark_tip > p {
    font-size: 0.24rem;
    color: #fff;
    white-space: nowrap;
    letter-spacing: 0.005rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/Photo.vue